module.exports = __webpack_public_path__ + "img/gas.7878b9de.png";